import React from 'react'

const Manage_salesmen = () => {
  return (
    <div>Manage_salesmen</div>
  )
}

export default Manage_salesmen